import { t } from 'i18next';
import * as yup from 'yup';

export const assignManufacturerSchema = (isSelect = false) =>
  yup.object().shape({
    manufacturer: isSelect
      ? yup.number().label(t('labelManufacturer')).nullable().required()
      : yup.object().label(t('labelManufacturer')).nullable().required(),
  });
